import { render } from "./OnboardingLegalRepresentativePage.vue?vue&type=template&id=0e924293&scoped=true"
import script from "./OnboardingLegalRepresentativePage.vue?vue&type=script&lang=js"
export * from "./OnboardingLegalRepresentativePage.vue?vue&type=script&lang=js"

import "./OnboardingLegalRepresentativePage.vue?vue&type=style&index=0&id=0e924293&lang=scss"
import "./OnboardingLegalRepresentativePage.vue?vue&type=style&index=1&id=0e924293&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e924293"]])

export default __exports__